module.exports = __webpack_public_path__ + "static/media/logo-white.d28debf7.svg";